module.exports = __webpack_public_path__ + "static/media/icon_camera.9055634e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_camera.svg
// module id = 519
// module chunks = 0